import { useCallback, useEffect, useState } from 'react';
import { IconEdit, IconLoader, IconTrash, SelectItemProps } from '@ui/src';
import { FeeSettingItemTypes } from './types';
import { useLazyGetPSPExternalAccountQuery } from '../../hoc/bank-and-psp/store/services';

import cn from './info.module.css';

const FeeSettingItem = ({
  casp,
  feeSettingItem,
  accountsList,
  onDeleteClick,
  onEditClick,
  editIsAvailable,
  deleteIsAvailable,
}: FeeSettingItemTypes) => {
  const [currentAccount, setCurrentAccount] = useState<
    SelectItemProps | undefined
  >(undefined);

  const [getPspExternaAccount, { isLoading, isFetching }] =
    useLazyGetPSPExternalAccountQuery();

  const getPspExternaAccountAction = useCallback(async (id: string) => {
    const response = await getPspExternaAccount(id);

    if (response?.data?.data) {
      setCurrentAccount({
        name: response?.data?.data?.account?.description,
        description: response?.data?.data?.iban,
        value: response?.data?.data.id,
        suffix: response?.data?.data?.account?.fullNumber,
      });
    }
  }, []);

  useEffect(() => {
    if (
      feeSettingItem &&
      accountsList &&
      feeSettingItem?.feeIntegrationAccountId
    ) {
      if (
        accountsList?.find(
          (item) => item.value === feeSettingItem?.feeIntegrationAccountId,
        )
      ) {
        setCurrentAccount(
          accountsList?.find(
            (item) => item.value === feeSettingItem?.feeIntegrationAccountId,
          ),
        );
      } else {
        getPspExternaAccountAction(feeSettingItem.feeIntegrationAccountId);
      }
    }
  }, [accountsList, feeSettingItem]);

  return (
    <div className={cn.feeSettingItem}>
      <div className={cn.feeSettingItemTop}>
        <div className={cn.feeSettingItemTitle}>
          {casp?.find((item) => item.value === feeSettingItem?.caspId)?.name}
        </div>
        <div className={cn.feeSettingItemControls}>
          {editIsAvailable && (
            <button
              type="button"
              className={cn.feeSettingItemControlButton}
              onClick={onEditClick}
            >
              <IconEdit width={16} height={16} />
            </button>
          )}
          {deleteIsAvailable && (
            <button
              type="button"
              className={cn.feeSettingItemControlButton}
              onClick={onDeleteClick}
            >
              <IconTrash width={16} height={16} />
            </button>
          )}
        </div>
      </div>
      <div className={cn.feeSettingItemBottom}>
        <div className={cn.feeSettingItemTier}>
          {`${feeSettingItem?.feeTier?.charAt(0)}${feeSettingItem?.feeTier?.slice(1).toLowerCase()}`}
        </div>

        {isLoading ||
          (isFetching && (
            <div className={cn.feeSettingItemAccountLoader}>
              <IconLoader width={20} height={20} />
            </div>
          ))}
        {currentAccount && (
          <>
            <div className={cn.feeSettingItemAccountValue}>
              {currentAccount?.name}
            </div>
            <div className={cn.feeSettingItemAccountValue}>
              ({currentAccount?.suffix}, {currentAccount?.description})
            </div>
          </>
        )}
      </div>
    </div>
  );
};

export default FeeSettingItem;
